import React from 'react'

import IconAngleDown from './IconAngleDown'
import IconAngleRight from './IconAngleRight'
import IconArrowRight from './IconArrowRight'
import IconBag from './IconBag'
import IconClose from './IconClose'
import IconCloseInCircle from './IconCloseInCircle'
import IconEasy from './IconEasy'
import IconEmail from './IconEmail'
import IconExchange from './IconExchange'
import IconExchange30 from './IconExchange30'
import IconExclamatoryMark from './IconExclamatoryMark'
import IconFacebook from './IconFacebook'
import IconHeadphone from './IconHeadphone'
import IconHseLogo from './IconHseLogo'
import IconInstagram from './IconInstagram'
import IconLoggedIn from './IconLoggedIn'
import IconLoggedOut from './IconLoggedOut'
import IconMagnifier from './IconMagnifier'
import IconMedal from './IconMedal'
import IconMenu from './IconMenu'
import IconPhone from './IconPhone'
import IconShield from './IconShield'
import IconTopDeal from './IconTopDeal'
import IconTv from './IconTv'
import IconYoutube from './IconYoutube'

import { TIconProps } from './iconProps'
import IconWhatsApp from './IconWhatsApp'
import IconCloseExperiment from './IconCloseExperiment'

export const enum EIconId {
  ANGLE_DOWN = 'ANGLE_DOWN',
  ANGLE_RIGHT = 'ANGLE_RIGHT',
  ARROW_RIGHT = 'ARROW_RIGHT',
  BAG = 'BAG',
  CLOSE = 'CLOSE',
  CLOSE_IN_CIRCLE = 'CLOSE_IN_CIRCLE',
  CLOSE_EXPERIMENT = 'CLOSE_EXPERIMENT',
  EASY = 'EASY',
  EMAIL = 'EMAIL',
  EXCHANGE = 'EXCHANGE',
  EXCHANGE30 = 'EXCHANGE30',
  EXCLAMATORY_MARK = 'EXCLAMATORY_MARK',
  FACEBOOK = 'FACEBOOK',
  HEADPHONE = 'HEADPHONE',
  HSE_LOGO = 'HSE_LOGO',
  INSTAGRAM = 'INSTAGRAM',
  LOGGED_IN = 'LOGGED_IN',
  LOGGED_OUT = 'LOGGED_OUT',
  MAGNIFIER = 'MAGNIFIER',
  MEDAL = 'MEDAL',
  MENU = 'MENU',
  PHONE = 'PHONE',
  SHIELD = 'SHIELD',
  TOP_DEAL = 'TOP_DEAL',
  TV = 'TV',
  YOUTUBE = 'YOUTUBE',
  WHATSAPP = 'WHATSAPP',
}

const Icon: React.FC<{ id: EIconId } & TIconProps> = (props) => {
  const { id, ...properties } = props
  return (
    <>
      {id === EIconId.ANGLE_DOWN && <IconAngleDown {...properties} />}
      {id === EIconId.ANGLE_RIGHT && <IconAngleRight {...properties} />}
      {id === EIconId.ARROW_RIGHT && <IconArrowRight {...properties} />}
      {id === EIconId.BAG && <IconBag {...properties} />}
      {id === EIconId.CLOSE && <IconClose {...properties} />}
      {id === EIconId.CLOSE_EXPERIMENT && <IconCloseExperiment {...properties} />}
      {id === EIconId.CLOSE_IN_CIRCLE && <IconCloseInCircle {...properties} />}
      {id === EIconId.EASY && <IconEasy {...properties} />}
      {id === EIconId.EMAIL && <IconEmail {...properties} />}
      {id === EIconId.EXCHANGE && <IconExchange {...properties} />}
      {id === EIconId.EXCHANGE30 && <IconExchange30 {...properties} />}
      {id === EIconId.EXCLAMATORY_MARK && <IconExclamatoryMark {...properties} />}
      {id === EIconId.FACEBOOK && <IconFacebook {...properties} />}
      {id === EIconId.HEADPHONE && <IconHeadphone {...properties} />}
      {id === EIconId.HSE_LOGO && <IconHseLogo {...properties} />}
      {id === EIconId.INSTAGRAM && <IconInstagram {...properties} />}
      {id === EIconId.LOGGED_IN && <IconLoggedIn {...properties} />}
      {id === EIconId.LOGGED_OUT && <IconLoggedOut {...properties} />}
      {id === EIconId.MAGNIFIER && <IconMagnifier {...properties} />}
      {id === EIconId.MEDAL && <IconMedal {...properties} />}
      {id === EIconId.MENU && <IconMenu {...properties} />}
      {id === EIconId.PHONE && <IconPhone {...properties} />}
      {id === EIconId.SHIELD && <IconShield {...properties} />}
      {id === EIconId.TOP_DEAL && <IconTopDeal {...properties} />}
      {id === EIconId.TV && <IconTv {...properties} />}
      {id === EIconId.YOUTUBE && <IconYoutube {...properties} />}
      {id === EIconId.WHATSAPP && <IconWhatsApp {...properties} />}
    </>
  )
}

export default Icon
